// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// aliased
import Link from 'components/Link';

// local
import styles from './NotFoundView.pcss';

export default class NotFoundView extends PureComponent {
  
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }
  static defaultProps = {}
  
  render() {
    const { location } = this.props;

    return (
      <div className={ styles.notFoundView }>
        <div className={ styles.copy }>
          <h1>{ 'Not Found' }</h1>
          <h2>{ `The requested URL ${ location.pathname } was not found` }</h2>
          <h2 className={ styles.home }>
            <Link to='/'>{ '← Home' }</Link>
          </h2>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/NotFoundView/index.jsx